import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import SpecraLockup from '../../../assets/brand/specra-lockup-charcoal.svg?url';
import SpecraMark from '../../../assets/brand/specra-mark-charcoal.svg?url';
import { cn } from '../../../lib/utils';
/** Brand artwork that can be replaced safely by a federated host. */ export const SpecraLogo = /*#__PURE__*/ React.forwardRef(({ aspectRatio, className, color, darkLockupSrc, darkMarkSrc, height, imageProps, invertInDarkMode, label = 'Specra.AI', lockupSrc = SpecraLockup, markSrc = SpecraMark, showMark, size, style, tone = 'auto', variant = 'lockup', ...props }, ref)=>{
    const resolvedVariant = showMark === undefined ? variant : showMark ? 'mark' : 'lockup';
    const artwork = resolvedVariant === 'mark' ? markSrc : lockupSrc;
    const darkArtwork = resolvedVariant === 'mark' ? darkMarkSrc : darkLockupSrc;
    const usesBundledArtwork = resolvedVariant === 'mark' ? markSrc === SpecraMark : lockupSrc === SpecraLockup;
    const shouldAutoInvert = invertInDarkMode ?? (usesBundledArtwork && !darkArtwork);
    const maskImage = `url(${JSON.stringify(artwork)})`;
    const width = size ?? (height === undefined ? resolvedVariant === 'mark' ? 'var(--space-6)' : 'var(--component-logo-lockup-width)' : undefined);
    const imageClassName = cn('block', height === undefined ? 'h-auto w-full' : 'h-full w-auto', imageProps?.className);
    const decorative = label.length === 0;
    return(// biome-ignore lint/a11y/useAriaPropsSupportedByRole: non-empty labels conditionally pair with role="img"; empty labels are decorative.
    /*#__PURE__*/ _jsx("span", {
        ...props,
        "aria-hidden": decorative || undefined,
        "aria-label": decorative ? undefined : label,
        className: cn('inline-flex shrink-0', !color && tone === 'light' && 'invert', !color && tone === 'auto' && shouldAutoInvert && 'dark:invert', className),
        ref: ref,
        role: decorative ? undefined : 'img',
        style: {
            height,
            width,
            ...style
        },
        children: color ? /*#__PURE__*/ _jsx("span", {
            "aria-hidden": "true",
            className: "block h-auto w-full",
            style: {
                aspectRatio: aspectRatio ?? (resolvedVariant === 'mark' ? 1 : 'var(--component-logo-ratio)'),
                backgroundColor: color,
                WebkitMask: `${maskImage} center / contain no-repeat`,
                mask: `${maskImage} center / contain no-repeat`
            }
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("img", {
                    alt: "",
                    ...imageProps,
                    className: cn(imageClassName, darkArtwork && 'dark:hidden'),
                    src: artwork
                }),
                darkArtwork ? /*#__PURE__*/ _jsx("img", {
                    alt: "",
                    ...imageProps,
                    className: cn(imageClassName, 'hidden dark:block'),
                    src: darkArtwork
                }) : null
            ]
        })
    }));
});
SpecraLogo.displayName = 'SpecraLogo';
/** Compatibility wrapper for consumers that size the lockup by height. */ export const SpecraWordmark = /*#__PURE__*/ React.forwardRef(({ height = 24, ...props }, ref)=>/*#__PURE__*/ _jsx(SpecraLogo, {
        ...props,
        height: height,
        ref: ref,
        variant: "lockup"
    }));
SpecraWordmark.displayName = 'SpecraWordmark';
